import { createFeatureSelector, createSelector } from "@ngrx/store";
import { PaymentLinkInformation } from "../../interfaces";

const paymentLinkFeature = createFeatureSelector<PaymentLinkInformation>('paymentLink');

const getPaymentLink = (data: PaymentLinkInformation): string => data.paymentLink.paymentLink;

const getPaymentLinkLoading = (data: PaymentLinkInformation): boolean => data.loading;

const getPaymentLinkError = (data: PaymentLinkInformation): boolean => data.paymentLinkError;

export const getPaymentLinkSelector = createSelector(
    paymentLinkFeature,
    getPaymentLink
);

export const getPaymentLinkLoadingSelector = createSelector(
    paymentLinkFeature,
    getPaymentLinkLoading
);

export const getPaymentLinkErrorSelector = createSelector(
    paymentLinkFeature,
    getPaymentLinkError
);